// vue-loading-overlay ==> https://openbase.com/js/vue-loading-overlay/documentation
export let defaultLoadingOptions = {
  active: false, // Show loading by default when true, use it as v-model:active
  canCancel: false, // Allow user to cancel by pressing ESC or clicking outside
  onCancel: () => {
    // Do something upon cancel, works in conjunction with can-cancel
    console.log('vue-loading-overlay onCancel')
  },
  isFullPage: true, // When false; limit loader to its container^
  transition: 'fade', // Transition name
  color: '#3E7EFF', // Customize the color of loading icon
  height: 100, // Customize the height of loading icon
  width: 100, // Customize the width of loading icon
  loader: 'spinner', // Name of icon shape you want use as loader, spinner or dots or bars
  backgroundColor: '#ffffff', // Customize the overlay background color
  opacity: 0.5, // Customize the overlay background opacity
  zIndex: 9999, // Customize the overlay z-index
  enforceFocus: true, // Force focuses on loader
  lockScroll: false, // Freeze the scrolling during full screen loader
  blur: '2px' // Value for the CSS blur backdrop-filter. Set to null or an empty string to disable blurring
}



// WEBPACK FOOTER //
// ./src/script/defaultConfig.js